import { sendGAEvent } from "@next/third-parties/google";

export function sendAddToCartEvent(item: any) {
  sendGAEvent("event", "add_to_cart", {
    currency: "USD",
    value: item.totalPrice,
    items: [
      {
        item_id: item.product.code,
        item_name: item.product.title,
        price: item.price,
        quantity: item.quantity,
      },
    ],
  });
}
